import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CibilDashboardComponent } from './cibil-dashboard.component';


const routes: Routes = [
  {
    path: '',
    component: CibilDashboardComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CibilDashboardRoutingModule { }
